import React, { memo, useMemo } from 'react'
import { IShipperRateTypes } from 'types/graphqlTypes'
import ShipmentIcons, {
  IShipmentIconsProps,
  getIcons,
} from 'apps/marketplace/pages/shipment-details/components/ShipmentIcons'
import { HIGH_DECLARED_VALUE_AMOUNT } from 'constants/shipments'
import { IShipmentCardInfoFragment } from '../../graphql/ShipmentCardInfoFragment'

export interface IShipmentDetailsCardIconsProps
  extends Pick<IShipmentCardInfoFragment, 'characteristics' | 'declaredValue' | 'shipperRateType'>,
    Pick<IShipmentIconsProps, 'stops'> {}

const ShipmentDetailsCardIcons = memo<IShipmentDetailsCardIconsProps>(
  ({ characteristics, declaredValue, shipperRateType, stops }) => {
    const { bounceCount, rolloverCount } = characteristics || {}

    const icons = useMemo(() => {
      return getIcons({
        ...characteristics,
        pricedUnderContract: Boolean(
          shipperRateType && shipperRateType === IShipperRateTypes.contract_primary
        ),
        contractBackup: Boolean(
          shipperRateType && shipperRateType === IShipperRateTypes.contract_backup
        ),
        sameDaySpot: shipperRateType === IShipperRateTypes.spot,
        cargoValue: declaredValue != null && declaredValue >= HIGH_DECLARED_VALUE_AMOUNT,
      })
    }, [characteristics, declaredValue, shipperRateType])

    return (
      <ShipmentIcons
        icons={icons}
        bouncedCount={bounceCount}
        rolledCount={rolloverCount}
        stops={stops}
      />
    )
  }
)

export default ShipmentDetailsCardIcons
